import { IntlShape } from 'react-intl';
import { GridColDef, GridFilterOperator, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { DocumentationViewItem } from 'store/documentation/model/types';
import { DataGridColumnsFactory } from 'components/common/dataGrid/columnsFactory';
import {
  getCreatedByOperator,
  getModifiedByOperator,
} from 'components/common/dataGrid/columnsFactory/customFilters';
import { DocumentationNameWithIconCell } from './components/DocumentationNameWithIconCell';
import { DocumentationExportedFromIssueCell } from './components/DocumentationExportedFromIssueCell';
import { DocumentationParentDirectoryCell } from './components/DocumentationParentDirectoryCell';

export class DocumentationColumnsFactory extends DataGridColumnsFactory<DocumentationViewItem> {
  private readonly createdByOperator: GridFilterOperator;
  private readonly modifiedByOperator: GridFilterOperator;

  constructor(
    intl: IntlShape,
    timezone: string,
    private organizationId: string
  ) {
    super(intl, timezone);
    this.organizationId = organizationId;
    this.createdByOperator = getCreatedByOperator(intl);
    this.modifiedByOperator = getModifiedByOperator(intl);
  }

  private readonly renderDocumentationNameCell = (
    params: GridRenderCellParams<DocumentationViewItem>
  ) => {
    return (
      <DocumentationNameWithIconCell
        cellData={params.value}
        rowData={params.row}
      />
    );
  };

  private readonly renderExportedFromIssueCell = (
    params: GridRenderCellParams<DocumentationViewItem>
  ) => {
    return <DocumentationExportedFromIssueCell rowData={params.row} />;
  };

  private readonly renderParentDirectoryCell = (
    params: GridRenderCellParams<DocumentationViewItem>
  ) => {
    return <DocumentationParentDirectoryCell rowData={params.row} />;
  };

  create(): GridColDef<DocumentationViewItem>[] {
    return [
      {
        ...this.name(),
        renderCell: this.renderDocumentationNameCell,
      },
      this.number(),
      {
        ...this.createdBy(this.organizationId, this.intl),
        filterOperators: [this.createdByOperator],
      },
      this.createdAt(this.intl, this.timezone),
      {
        ...this.modifiedBy(this.organizationId, this.intl),
        filterOperators: [this.modifiedByOperator],
      },
      this.modifiedAt(this.intl, this.timezone),
      this.relatedIssuesCount(),
      this.site(this.intl),
      this.level(this.intl),
      {
        ...this.exportedFromIssue(),
        renderCell: this.renderExportedFromIssueCell,
      },
      {
        ...this.parentDirectory(),
        sortable: false,
        renderCell: this.renderParentDirectoryCell,
      },
      { ...this.documentState(this.intl), filterable: false },
    ];
  }
}
